module.exports = __webpack_public_path__ + "958600363e263eefba8341636a6bf93e.svg";